export enum CourseInformationTab {
  ROSTER_MANAGEMENT = "roster-management",
  COMMUNITY = "community",
  ANNOUNCEMENTS = "announcements",
  COURSE_CATALOG_INFO = "course-catalog-info",
  SETTINGS = "settings",
}
